import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingClientDocument,
  useClientSaveSigningContractStepMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useClientSaveSigningContract = () => {
  const [handle, { loading, error: apolloError }] =
    useClientSaveSigningContractStepMutation({
      refetchQueries: [OnboardingClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  return {
    loading,
    error,
    signingContract: useCallback(
      async (clientId: string, otpCode: string) => {
        const res = await handle({
          variables: { id: clientId, otpCode },
        });

        return !!res.data?.clientSaveSigningContractStep;
      },
      [handle]
    ),
  };
};
